import AddHoldingModal from "./add-holding-modal";

export default AddHoldingModal;
